import React, { useRef } from "react"
import { useParams } from "react-router-dom"
import { useAppCtx } from "lib/state"
import _ from "lodash"; 
import { randoms } from "lib/utils"

/*
  const result = _.update(testObj, "education[0].coures[0].grade", (grade) => "A+")
  const result2 = _.set(testObj, "education[0].coures[0].grade", "A+")
  const result3 = _.set(testObj, "education[0].coures", [...testObj.education[0].coures, { name: "english", grade: "A" }])
*/

export default function useAppStore( store:any, setStore:any, refs:any ){

  const { tmplid } = useParams()
  const { appTools }:any = useAppCtx()

  // const { data:_Template } = queryTools.resource.getById({ resource: "template", _id: tmplid })

  const update = (path: string, value: any) => {
    setStore((prev: any) => {
      const current = _.get(prev, path);
      if (_.isEqual(current, value)) {
        return prev; // No change — skip update
      }
  
      const clone = _.cloneDeep(prev);
      _.set(clone, path, value);
      return clone;
    });
  };

  const updateActive = (type: string, data: any) => {
    setStore((prev: any) => {
      const existing = prev.actives[type];
      const merged = { ...existing, ...data };
  
      if (_.isEqual(existing, merged)) return prev;
  
      const clone = _.cloneDeep(prev);
      _.set(clone, `actives.${type}`, merged);
      return clone;
    });
  
    syncActiveToCollection(type);
  };
  

  const setActive = (type: string, data: any) => {
    setStore((prev: any) => {
      if (_.isEqual(prev.actives[type], data)) return prev;
  
      const clone = _.cloneDeep(prev);
      _.set(clone, `actives.${type}`, data);
      return clone;
    });
  };

  const get = (type:string) => store[type]
  const getActive = (type:string) => store.actives[type]
  const getMeta = (type:string) => store.metas[type]
  const getCollection = (type:string) => store.collections[type]

  
  /* === updates the collections array with the updated active object === */
  const syncActiveToCollection = (type: string) => {
    setStore((prev: any) => {
      const active = prev.actives[type];
      const updatedCollection = prev.collections[type]?.map((item: any) => {
        return item.refstr === active.refstr ? { ...item, ...active } : item;
      });
  
      if (_.isEqual(prev.collections[type], updatedCollection)) return prev;
  
      return {
        ...prev,
        collections: {
          ...prev.collections,
          [type]: updatedCollection
        }
      };
    });
  };

  /* === updates the active object with the updated collection object === */
  const syncCollectionToActive = (type:string) => {
    setStore( (prev:any) => {
      const itemFound = prev.collections[type].find( (item:any) => item.refstr === prev.actives[type].refstr )
      return { ...prev, actives: { ...prev.actives, [type]: itemFound } }
    })
  }


  const swapItemsInActiveState = (type:string, targetRefStr:string) => {
    setStore( (prev:any) => {
      if( prev.collections[type].length < 2 ) return prev

      const clone = _.cloneDeep(prev)
      const active = clone.actives[type]
      const collection = clone.collections[type]

      const newState = {
        ...clone,
        actives: {
          ...clone.actives,
          [type]: collection.find( (item:any) => item.refstr === targetRefStr )
        },
        collections: {
          ...clone.collections,
          [type]: collection.map( (item:any) => {
            if( item.refstr === active.refstr ){
              return { ...item, ...active }
            } else {
              return item
            }
          })
        }
      }

      const newStatePassContent = newState.actives.statement.content?.pass || ""
      const newStateFailContent = newState.actives.statement.content?.fail || ""

      if( !refs.current.statements[newState.actives.statement.refstr] ){
        refs.current.statements[newState.actives.statement.refstr] = {
          content: {
            pass: newStatePassContent,
            fail: newStateFailContent
          }
        }
      } else {
        refs.current.statements[newState.actives.statement.refstr].content.pass = newStatePassContent
        refs.current.statements[newState.actives.statement.refstr].content.fail = newStateFailContent
      }


      refs.current.statements[newState.actives.statement.refstr].content.pass = newStatePassContent
      refs.current.statements[newState.actives.statement.refstr].content.fail = newStateFailContent

      console.log(newState)
      return newState
    })
  }


  const saveActiveContentOnly = (templateDbObj:any) => {
    const activeStatement = store.actives.statement
    const currentPassContent = refs.current.content.pass
    const currentFailContent = refs.current.content.fail

    if( !templateDbObj ) return

    const newTemplate = { ...templateDbObj }

  }


  const synchronizeStatements = (templateDbObj:any) => {
    let result:any = {}

    setStore( (prev:any) => {
      
      const clone = _.cloneDeep(prev)

      let newState = {
        ...templateDbObj,
        ...clone.template,
        Elements: templateDbObj.Elements.map( (elem:any) => {
          if( elem.refstr !== "opening_statements" ) return elem;
          return {
            ...elem,
            config: {
              ...elem.config,
              statements: elem.config.statements.map( (statementObj:any) => {
                if( statementObj.refstr !== clone.actives.statement.refstr ) return statementObj;
                return {
                  ...statementObj,
                  conditional: {
                    ...statementObj.conditional,
                    ...clone.actives.statement.conditional
                  },
                  content: clone.actives.statement.content
                  // content: {
                  //   pass: refs.current.statements[clone.actives.statement.refstr].content.pass,
                  //   fail: refs.current.statements[clone.actives.statement.refstr].content.fail
                  // }
                }
              })
            }
          }
        })
      }
      result = newState
      return newState
    })
    return result
  }


  const AppStore = {
    get,
    getActive,
    getCollection,
    getMeta,
    saveActiveContentOnly,
    setActive,
    setStore,
    swapItemsInActiveState,
    synchronizeStatements,
    syncActiveToCollection,
    syncCollectionToActive,
    update,
    updateActive
  }

  return AppStore

}